import { Controller } from "@hotwired/stimulus"

// Auto-growing textarea: expands to fit its content as the user types, so long
// text is never clipped or trapped behind an inner scrollbar. Attach with
// data-controller="autosize" on any <textarea>. Works alongside other
// controllers targeting the same element.
export default class extends Controller {
  connect() {
    this._resize = this._resize.bind(this)
    this.element.addEventListener("input", this._resize)
    // The content — not a fixed rows= — drives the height.
    this.element.style.overflowY = "hidden"
    this.element.style.resize = "none"
    // Fit any pre-filled value on load. Two rAFs so it runs after layout, in
    // case the field starts hidden (inside a tab/panel shown later).
    requestAnimationFrame(() => requestAnimationFrame(this._resize))
  }

  disconnect() {
    this.element.removeEventListener("input", this._resize)
  }

  _resize() {
    const el = this.element
    if (el.offsetParent === null) return // still hidden — scrollHeight is 0
    el.style.height = "auto"
    el.style.height = `${el.scrollHeight}px`
  }
}
